import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import React from "react";

const breakpointKeys = ["xs", "sm", "md", "lg", "xl"];

const Hidden = ({
  children,
  only,
  xsUp,
  smUp,
  mdUp,
  lgUp,
  xlUp,
  xsDown,
  smDown,
  mdDown,
  lgDown,
  xlDown,
}) => {
  const theme = useTheme();

  const hideByUp =
    (xsUp && useMediaQuery(theme.breakpoints.up("xs"))) ||
    (smUp && useMediaQuery(theme.breakpoints.up("sm"))) ||
    (mdUp && useMediaQuery(theme.breakpoints.up("md"))) ||
    (lgUp && useMediaQuery(theme.breakpoints.up("lg"))) ||
    (xlUp && useMediaQuery(theme.breakpoints.up("xl")));

  const hideByDown =
    (xsDown && useMediaQuery(theme.breakpoints.down("xs"))) ||
    (smDown && useMediaQuery(theme.breakpoints.down("sm"))) ||
    (mdDown && useMediaQuery(theme.breakpoints.down("md"))) ||
    (lgDown && useMediaQuery(theme.breakpoints.down("lg"))) ||
    (xlDown && useMediaQuery(theme.breakpoints.down("xl")));

  const onlyValues = Array.isArray(only) ? only : only ? [only] : [];
  const hideByOnly = onlyValues.some((bp) => {
    if (!breakpointKeys.includes(bp)) {
      return false;
    }
    return useMediaQuery(theme.breakpoints.only(bp));
  });

  if (hideByUp || hideByDown || hideByOnly) {
    return null;
  }

  return <>{children}</>;
};

Hidden.propTypes = {
  children: PropTypes.node,
  only: PropTypes.oneOfType([
    PropTypes.oneOf(breakpointKeys),
    PropTypes.arrayOf(PropTypes.oneOf(breakpointKeys)),
  ]),
  xsUp: PropTypes.bool,
  smUp: PropTypes.bool,
  mdUp: PropTypes.bool,
  lgUp: PropTypes.bool,
  xlUp: PropTypes.bool,
  xsDown: PropTypes.bool,
  smDown: PropTypes.bool,
  mdDown: PropTypes.bool,
  lgDown: PropTypes.bool,
  xlDown: PropTypes.bool,
};

Hidden.defaultProps = {
  children: null,
  only: undefined,
  xsUp: false,
  smUp: false,
  mdUp: false,
  lgUp: false,
  xlUp: false,
  xsDown: false,
  smDown: false,
  mdDown: false,
  lgDown: false,
  xlDown: false,
};

export default Hidden;
